import useAppContext from "../components/AppContext";

export const useStyles = (
  stylesDefault,
  stylesSequence,
  forceStylesSequence = false
) => {
  const { theme } = useAppContext();

  if (theme === "sequence" || forceStylesSequence) {
    return stylesSequence;
  }

  return stylesDefault;
};
